import React from "react";
import type { ConnectionType } from "components/canvas/leftSide/import/Postgres/savedConnectionsApi";
import { ICON } from "./ConnectionTypeIcon";

interface Props {
  type: ConnectionType;
  className?: string;
  /** sm = 24px tile (list rows). md = 32px tile (dialog headers). */
  size?: "sm" | "md";
}

export const ConnectionAssetIcon: React.FC<Props> = ({
  type,
  className,
  size = "sm",
}) => {
  const Icon = ICON[type];
  const tileClass = size === "md" ? "w-8 h-8" : "w-6 h-6";
  const iconPx = size === "md" ? 18 : 14;
  return (
    <div
      className={`${tileClass} rounded-app bg-bg-hover border border-border flex items-center justify-center shrink-0 ${className ?? ""}`}
      aria-hidden="true"
    >
      <Icon width={iconPx} height={iconPx} className="text-fg-muted" />
    </div>
  );
};
